<template>
    <div>
        <form class="form-rest" @submit.prevent="form">
            <div class="card-header">
                <div class="text-left">
                    <button type="submit" class="btn btn-success" :disabled="btnSave">
                        <i class="fas fa-save"></i> {{ $t("lang.label_save") }}
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div
                        class="col-md-12"
                        v-if="variantOptions === true"
                        style="text-align: center"
                    >
                        <div class="alert alert-danger">
                            <strong> {{ msjError }} </strong>
                        </div>
                    </div>
                    <div class="col-md-8 offset-md-2">
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="city">{{ $t("lang.label_name") }}:</label>
                                <input
                                    type="text"
                                    v-model="namex"
                                    class="form-control"
                                    v-if="action === 'editForm' || action === 'addForm'"
                                />
                                <input
                                    type="text"
                                    v-model="namex"
                                    class="form-control"
                                    v-if="action === 'variantFormAside'"
                                    disabled
                                />                                
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="description">{{
                                    $t("lang.label_name_preview")
                                }}</label>
                                <input
                                    type="text"
                                    v-model="fx.preview_name"
                                    class="form-control"                                    
                                    v-if="action === 'editForm' || action === 'addForm'"
                                />
                                <input
                                    type="text"
                                    v-model="fx.preview_name"
                                    class="form-control"
                                    v-if="action === 'variantFormAside'"
                                    disabled
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12" style="margin-top: 17px;">
                                <draggable
                                    v-if="fx.taks.length > 0"
                                    v-model="fx.taks"
                                    tag="div"
                                    class="col-md-12"
                                    v-bind="dragOptions"
                                    @start="isDragging = true"
                                    @end="isDragging = false"
                                    handle=".moveCatx"
                                >
                                    <div class="row list-group-item list-group-item-action Ajust" v-for="(i, index) in fx.taks" :key="index">
                                        <div class="moveCatx" v-if="noPrice === true">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </div>                        
                                        <div class="" style="margin-left: -9px;">
                                            <input v-if="action !== 'variantFormAside'"
                                                type="text"
                                                class="form-control AjustB"
                                                v-model="i.name"
                                                placeholder="Opciones"
                                                :ref="'taks' + index"
                                                :id="'taks' + index"
                                                style="width: 99% !important;"
                                            />
                                            <input v-if="action !== 'variantFormAside'"
                                                type="hidden"
                                                class="form-control AjustC"
                                                v-model="i.price"
                                                placeholder="0.00"
                                                :ref="'taks' + index"
                                                :id="'taks' + index"
                                            />
                                          
                                           <input v-if="action === 'variantFormAside'"
                                                type="text"
                                                class="form-control AjustB"
                                                v-model="i.name"
                                                placeholder="Opciones"
                                                :ref="'taks' + index"
                                                :id="'taks' + index"
                                                style="width: 62% !important;"
                                            />                                            
                                            <input v-if="action === 'variantFormAside'"
                                                type="text"
                                                class="form-control AjustC"
                                                v-model="i.price"
                                                placeholder="0.00"
                                                :ref="'taks' + index"
                                                :id="'taks' + index"
                                            />                                                                       
                                        </div>                            
                                        <div class="cdropdown btnViewMore float-right AjustD">
                                            <button
                                                type="button"
                                                class="btn btn-danger"
                                                :disabled="f.taks.length === 1"
                                                @click="delTaks(i.id, index)"
                                                style="
                                                    border-radius: 2px;
                                                    padding: 2px 4px;
                                                    font-size: 12px;
                                                "
                                            >
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>                      
                                    </div> 
                                </draggable>  
                                <button type="button" class="btn btn-info" @click="addLine()">
                                    <i class="fas fa-plus fa-lg"></i>
                                </button>                                                                                  
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
    name: "variantForm",
    components: {
        draggable,
    },
    data() {
        return {
            m: {
                show: false,
                component: "",
                data: {},
            },
            isDragging: false,
            datacat: [],
            namex: "",
            fx: {
                assing:0,
                agruparOpt: [],
                name: "",
                preview_name: "",
                taks: [],
                Utaks:[],
                org_id: window.localuserdata,
                user_id: window.master_client,
                category_id: 0,
                idPrices: 0,
                id: 0,
                price: "0.10",
                actionForm: "",
            },
            f: {
                assing:0,
                agruparOpt: [],
                inAgruparOpt: [],
                name: "",
                preview_name: "",
                taks: [],
                Utaks:[],
                org_id: window.localuserdata,
                user_id: window.master_client,
                category_id: 0,
                idPrices: 0,
                id: 0,
                price: "0.10",
                actionForm: "update",
            },
            btnSave: false,
            change: false,
            action: "variantFormAside",
            varian: false,
            agruparOpt: [],
            validar: [],
            id: 0,
            validado: [],
            variantOptions: false,
            msjError: "",
            noPrice: true,
        }
    },
    created () {
        this.init();
    },
    methods: {
        init() {
            let g = this.$store.getters["getOpenModal"];
            // console.log(g);
            if (g.component === "variantFormAside") {
               if (g.action !== undefined) {
                    this.action = g.action;
                }            
            }
            if (g.component === "variantForm") {
                if (g.action !== undefined) {
                    this.action = g.action;
                }                
                let r = g.data;
                if (r.validar !== undefined) {
                    this.validar = r.validar;
                    this.id = r.dat.id;
                } else {
                    this.id = r.dat.id;
                    this.getDat();
                }
                this.fx.actionForm = r.actionForm;
                this.namex = r.dat.name;
                this.fx.name = r.dat.name;
                this.fx.preview_name = r.dat.preview_name;
                if (r.dat.id !== 0) {
                    this.fx.agruparOpt.push(r.dat.id);
                    this.agruparOpt = r.dat.agruparOpt;
                    this.fx.category_id = r.dat.category_id;
                    this.fx.idPrices = r.dat.idPrices;
                    this.fx.price = r.dat.price;
                }

                this.varian = r.dat.varian;
                if (this.varian === true) {
                    this.change = true;
                    this.f.agruparOpt = this.fx.agruparOpt;
                    this.f.category_id = r.dat.category_id;
                    this.f.idPrices = r.dat.idPrices;
                }
                if (this.fx.agruparOpt.length === 0) {
                    let lineNew = {
                        id: 0,
                        name: null,
                        id_variant_cat: 0,
                        price: "0.10"
                    };
                    this.fx.taks.push(lineNew);
                    this.change = true;
                } else {
                    this.getData();
                }
            }
        },
        getDat() {
            let url = "/menu/variantcat";
            window.master
                .post(url, this.f)
                .then((response) => {
                    this.validar = response.data.res;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getData() {
            let url
            if (this.action === "variantFormAside") {               
                url = "/menu/variantopt";
            } else {
                url = "/menu/variantoptst";
            }            
            window.master
                .post(url, this.fx)
                .then((response) => {
                    console.log(response.data);
                    let u = response.data.res;
                    this.noPrice = response.data.Noprice
                    let m = [];                    
                    for (const i in u) {
                        let o = u[i];
                        // console.log(o);
                        for (const j in o) {
                            m.push(o[j]);
                        }
                    }
                    this.fx.taks = m;
                    let lineNew = {
                        id: 0,
                        name: null,
                        id_variant_cat: 0,
                        price: "0.10"
                    };
                    this.fx.taks.push(lineNew);
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        addLine() {
            let r = this.validateOptions();
            if (r === true) {
                this.variantOptions = true;
                this.btnSave = true;
                this.msjError = "Cada opción debe tener un nombre único.";
            } else {
                this.variantOptions = false;
                this.btnSave = false;
                this.msjError = "";
                let res = this.fx.taks.find((seach) => seach.name === null);
                if (res === undefined) {
                    // controlar la creacion de nuevas opciones
                    let lineNew = {
                        id: 0,
                        name: null,
                        id_variant_cat: 0,
                        price: "0.10"
                    };
                    this.fx.taks.push(lineNew);
                    let idx = this.fx.taks.length - 1;
                    setTimeout(function () {
                        let btnId = document.getElementById("taks" + idx);
                        if (btnId) {
                            btnId.focus();
                        }
                    }, 200);
                }
            }
        },
        delTaks(id, index) {
            this.fx.taks.splice(index, 1);
            this.validado.splice(index, 1);
            let r = this.validateOptions();
            if (r === true) {
                this.variantOptions = true;
                this.btnSave = true;
                this.msjError = "Cada opción debe tener un nombre único.";
            } else {
                this.variantOptions = false;
                this.btnSave = false;
                this.msjError = "";
                this.addLine();
            }
        },
        validateOptions() {
            let b = this.validado;
            let r = new Set(b).size !== b.length;
            return r;
        },
        moveCat() {
            // window.master.put("movecat", this.f)
            // .then((response) => {
            //     console.log(response);
            // })
            // .catch((error) => console.log(error));
        },       
        form() {
            let data = [];
            if (this.varian === true) {
                this.f.name = this.fx.name;
                this.f.preview_name = this.fx.preview_name;
                this.f.taks = this.fx.taks;
                this.f.id = this.f.idPrices
                data = this.f;
            } else {
                this.fx.name = this.namex;
                this.fx.id = this.fx.idPrices
                data = this.fx;
            }
            let e = []
            this.variantOptions = false;
            this.msjError = "";
            let taks = data.taks;
            let o = [];
            let ov = [];
            let j = []
            this.f.agruparOpt = []            
            for (let i in taks) {
                if (taks[i].name !== null) {
                    if (taks[i].name.length > 1 ) {
                        o.push(taks[i].name);
                        j.push(taks[i].id)
                        if (taks[i].id_variant_opt === undefined) {
                            ov.push({                                         
                                org_id:data.org_id,
                                user_id:data.user_id,
                                id_variant_cat:data.taks[0].id_variant_cat,
                                id_variant_opt:0,
                                id:taks[i].id,
                                name:taks[i].name,                                
                                price:taks[i].price
                            }) 
                        } else {
                            ov.push({                                         
                                org_id:data.org_id,
                                user_id:data.user_id,
                                id_variant_cat:taks[i].id_variant_cat,	
                                id_variant_opt:taks[i].id_variant_opt,
                                id:taks[i].id,
                                name:taks[i].name,                                
                                price:taks[i].price
                            }) 
                        }                        
                    }
                }
            }
            data.inAgruparOpt = j
            data.assing = data.taks[0].id_variant_cat            
            data.taks = ov
            if (o.length > 0) {
                this.variantOptions = false;
                this.msjError = "";
                this.$store.commit("setLoadingModal", true);
                let url
                if (this.action === "variantFormAside") {               
                    url = "/menu/variantformassing";
                } else {
                    url = "/menu/variantform";
                }
                // console.log(url);
                window.master
                    .post(url, data)
                    .then((response) => {
                        this.$swal.fire({
                            type: "success",
                            title: "Save!",
                            text: "Save Successful",
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        if (this.action === "variantFormAside") {
                            this.variantFormAsideReturn();
                        }
                        this.commit();
                    })
                    .catch((error) => console.log(error));
            } else {
                this.variantOptions = true;
                this.msjError = "No se ingresó el valor de la opción del artículo.";
            }
            // if (this.id > 0) {
            //     this.init();
            // }
        },
        validate(b) {
            let a = [];
            let name = b.name;
            let id = this.id;
            let r = this.validar;
            for (let i in r) {
                if (id !== r[i].id) {
                    if (name === r[i].name) {
                        a.push(true);
                    } else {
                        a.push(false);
                    }
                }
            }
            for (var i = a.length - 1; i >= 0; i--) {
                if (a.indexOf(a[i]) !== i) {
                    a.splice(i, 1);
                }
            }
            return a;
        },
        rest() {
            this.f.taks = [];
            let lineNew = {
                id: 0,
                name: null,
                id_variant_cat: 0,
                price: "0.10"
            };
            this.f.taks.push(lineNew);
            // this.init()
            this.f.preview_name = "";
            this.f.name = "";
            this.name = "";
        },
        variantFormAsideReturn() {
            let t = this;
            let data = {
                function: "variantFormAsideReturn",
                agruparOpt: t.agruparOpt,
                actions: "variant",
            };
            this.$store.commit("setvariantData", data);
        },
        commit() {
            this.$store.commit("setLoadingModal", false);
            this.$store.commit("setCloseModal", { action: "saved" });
            this.m = {
                show: false,
                component: "",
                data: {},
            };
            this.$store.commit("setOpenModal", this.m);
            if (this.action !== "variantFormAside") {
                this.rest();
            }
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    watch: {
        namex: function (val) {
            if (this.change === true) {
                this.fx.preview_name = val;
                this.fx.name = val;
            }
        },
        fx: {
            handler(val, oldVal) {
                let taks = val.taks;
                let o = [];
                for (let i in taks) {
                    if (taks[i].name !== null) {
                        if (taks[i].name.length > 1) {
                            o.push(taks[i].name);
                        }
                    }
                }
                if (o.length > 0) {
                    this.validado = o;
                }
            },
            deep: true,
        },
    },
}
</script>
<style lang="scss" scoped>
.moveCatx {
    position: absolute;
    top: 5px;
    left: -10px;
    width: 9px;
    height: 100%;
    background-color: #bfe8fb;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}
.AjustF{
    width: 100% !important;
    border: 1px solid #a5a5a4;
    border-radius: 6px;
}
.AjustE{
    margin-top: -8px !important;
    margin-bottom: 5px !important; 
    width: 100% !important;
    border: 1px solid #a5a5a4;
    border-radius: 6px;
}
.AjustD{
    right: 1px;
    margin-top: -6px; 
    margin-right: -38px;
}
.AjustC{
    width: 34% !important; 
    position: absolute; 
    right: 1px; 
    margin-top: -11px;
    margin-left: -19px;
    border: 1px solid #a5a5a4;
    border-radius: 6px;
    font-size: 0.8rem;
    padding: 0.375rem 0.75rem;
}
.AjustB{
    // width: 62% !important; 
    width: 90% !important; 
    position: absolute; 
    margin-top: -11px;
    margin-left: -9px; 
    border: 1px solid #a5a5a4;
    border-radius: 6px;
    font-size: 0.8rem;
    padding: 0.375rem 0.75rem;
}
.Ajust{
    margin-bottom: 21px !important; 
    margin-top: -10px; 
    margin-left: 1px !important; 
    border: 0px;
}
.moveCat {
    position: absolute;
    top: 0;
    left: -10px;
    width: 9px;
    height: 100%;
    background-color: #bfe8fb;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    cursor: pointer;
}
.table {
    width: 90% !important;
}
</style>
